import useResources from "./use-resources";
// @ts-expect-error pure js
import { findAndUpdate } from "../utils";
import type { MailLog } from "../models/mailLog";

interface UseMailLogsOptions {
  tenantId?: number;
}

export default function useMailLogs({ tenantId }: UseMailLogsOptions = {}) {
  const {
    resources: mailLogs,
    update,
    error,
    isLoading,
    axios,
    mutate,
  } = useResources<MailLog>("mail-logs", {
    params: tenantId !== undefined ? { tenant_id: tenantId } : undefined,
  });

  async function cancelMail(mailId: number) {
    await mutate(
      async (current) => {
        const response = await axios.put(`mail-logs/${mailId}/cancel`);
        return findAndUpdate(
          current ?? [],
          (mail: MailLog) => mail.id === mailId,
          response.data,
        );
      },
      { revalidate: false },
    );
  }

  async function sendNow(mailId: number) {
    await mutate(
      async (current) => {
        const response = await axios.put(`mail-logs/${mailId}/send-now`);
        return findAndUpdate(
          current ?? [],
          (mail: MailLog) => mail.id === mailId,
          response.data,
        );
      },
      { revalidate: false },
    );
  }

  function retrySending(id: number) {
    return update(id, {});
  }

  return {
    mailLogs,
    error,
    isLoading,
    retrySending,
    cancelMail,
    sendNow,
  };
}
